"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPaymentMethodToCompanySchema = exports.validateAddPaymentMethodRequest = exports.AddPaymentMethodSchema = exports.CVV_TEST = exports.CVV_MAX = exports.CVV_MIN = exports.CVV_MATCHES = exports.CVV_REQUIRED = exports.EXPIRY_TEST = exports.EXPIRY_MATCHES = exports.EXPIRY_REQUIRED = exports.CARD_NUMBER_TEST = exports.CARD_NUMBER_MATCHES = exports.CARD_NUMBER_MAX = exports.CARD_NUMBER_MIN = exports.CARD_NUMBER_REQUIRED = exports.CARD_NAME_MAX = exports.CARD_NAME_REQUIRED = exports.SUB_PLAN_REQUIRED = void 0;
const yup = __importStar(require("yup"));
const card_validator_1 = require("card-validator");
const ValidationError_1 = require("../errors/ValidationError");
exports.SUB_PLAN_REQUIRED = "Choose a subscription plan";
exports.CARD_NAME_REQUIRED = "Please enter name on the card";
exports.CARD_NAME_MAX = "Name can only be 100 characters long";
exports.CARD_NUMBER_REQUIRED = "Please enter card number";
exports.CARD_NUMBER_MIN = "Card number should be atleast 14 characters long";
exports.CARD_NUMBER_MAX = "Card number can only be max 16 characters long";
exports.CARD_NUMBER_MATCHES = "Card number should be numeric";
exports.CARD_NUMBER_TEST = "Card number is not valid";
exports.EXPIRY_REQUIRED = "Please enter expiry";
exports.EXPIRY_MATCHES = "Expiry date should be in MM/YY format";
exports.EXPIRY_TEST = "Invalid expiry date";
exports.CVV_REQUIRED = "Please enter CVV";
exports.CVV_MATCHES = "CVV should be numeric";
exports.CVV_MIN = "CVV should be min 3 digits";
exports.CVV_MAX = "CVV should be max 4 digits";
exports.CVV_TEST = "CVV is not valid";
/**
 * Schema for add payment method validation
 * {@link IAddPaymentMethodRequest}
 */
const AddPaymentMethodSchema = yup.object().shape({
    nameOnCard: yup
        .string()
        .when("isPaidPlan", (isPaidPlan, schema) => isPaidPlan ? schema.required(exports.CARD_NAME_REQUIRED).max(100, exports.CARD_NAME_MAX) : schema.notRequired()),
    cardNumber: yup.string().when("isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.CARD_NUMBER_REQUIRED)
            .matches(/^\d+$/, exports.CARD_NUMBER_MATCHES)
            .min(14, exports.CARD_NUMBER_MIN)
            .max(16, exports.CARD_NUMBER_MAX)
            .test("cardNumber", exports.CARD_NUMBER_TEST, (cardNumber) => (0, card_validator_1.number)(cardNumber).isValid)
        : schema.notRequired()),
    expiry: yup.string().when("isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.EXPIRY_REQUIRED)
            .length(5)
            .matches(/^\d\d\/\d\d$/, exports.EXPIRY_MATCHES)
            .test("expiry", exports.EXPIRY_TEST, (expiry) => (0, card_validator_1.expirationDate)(expiry).isValid)
        : schema.notRequired()),
    cvv: yup.string().when("isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.CVV_REQUIRED)
            // eslint-disable-next-line @typescript-eslint/no-shadow
            .when("cardNumber", (cardNumber, schema) => {
            const numberValidationResponse = (0, card_validator_1.number)(cardNumber);
            return schema.length(numberValidationResponse.isValid ? numberValidationResponse.card.code.size : 3, numberValidationResponse.isValid
                ? `CVV should be ${numberValidationResponse.card.code.size} digits long for this card type`
                : "CVV should be 3 digits long for this card type");
        })
            .matches(/^\d+$/, exports.CVV_MATCHES)
            .min(3, exports.CVV_MIN)
            .max(4, exports.CVV_MAX)
            // eslint-disable-next-line @typescript-eslint/no-shadow
            .when("cardNumber", (cardNumber, schema) => {
            const numberValidationResponse = (0, card_validator_1.number)(cardNumber);
            const maxLength = numberValidationResponse.isValid ? numberValidationResponse.card.code.size : 3;
            schema.test("cvv", exports.CVV_TEST, (cvvStr) => (0, card_validator_1.cvv)(cvvStr, maxLength).isValid);
        })
        : schema.notRequired()),
});
exports.AddPaymentMethodSchema = AddPaymentMethodSchema;
const AddPaymentMethodToCompanySchema = yup.object().shape({
    subscriptionPlan: yup.string().required(exports.SUB_PLAN_REQUIRED),
    nameOnCard: yup
        .string()
        .when("$isPaidPlan", (isPaidPlan, schema) => isPaidPlan ? schema.required(exports.CARD_NAME_REQUIRED).max(100, exports.CARD_NAME_MAX) : schema.notRequired()),
    cardNumber: yup.string().when("$isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.CARD_NUMBER_REQUIRED)
            .matches(/^\d+$/, exports.CARD_NUMBER_MATCHES)
            .min(14, exports.CARD_NUMBER_MIN)
            .max(16, exports.CARD_NUMBER_MAX)
            .test("cardNumber", exports.CARD_NUMBER_TEST, (cardNumber) => (0, card_validator_1.number)(cardNumber).isValid)
        : schema.notRequired()),
    expiry: yup.string().when("$isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.EXPIRY_REQUIRED)
            .length(5)
            .matches(/^\d\d\/\d\d$/, exports.EXPIRY_MATCHES)
            .test("expiry", exports.EXPIRY_TEST, (expiry) => (0, card_validator_1.expirationDate)(expiry).isValid)
        : schema.notRequired()),
    cvv: yup.string().when("$isPaidPlan", (isPaidPlan, schema) => isPaidPlan
        ? schema
            .required(exports.CVV_REQUIRED)
            // eslint-disable-next-line @typescript-eslint/no-shadow
            .when("cardNumber", (cardNumber, schema) => {
            const numberValidationResponse = (0, card_validator_1.number)(cardNumber);
            return schema.length(numberValidationResponse.isValid ? numberValidationResponse.card.code.size : 3, numberValidationResponse.isValid
                ? `CVV should be ${numberValidationResponse.card.code.size} digits long for this card type`
                : "CVV should be 3 digits long for this card type");
        })
            .matches(/^\d+$/, exports.CVV_MATCHES)
            .min(3, exports.CVV_MIN)
            .max(4, exports.CVV_MAX)
            // eslint-disable-next-line @typescript-eslint/no-shadow
            .when("cardNumber", (cardNumber, schema) => {
            const numberValidationResponse = (0, card_validator_1.number)(cardNumber);
            const maxLength = numberValidationResponse.isValid ? numberValidationResponse.card.code.size : 3;
            schema.test("cvv", exports.CVV_TEST, (cvvStr) => (0, card_validator_1.cvv)(cvvStr, maxLength).isValid);
        })
        : schema.notRequired()),
});
exports.AddPaymentMethodToCompanySchema = AddPaymentMethodToCompanySchema;
/**
 * Validates add payment method request schema
 * @param data: add payment method request {@link IAddPaymentMethodRequest} to validate
 */
const validateAddPaymentMethodRequest = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield AddPaymentMethodSchema.validate(data, { abortEarly: false });
        return;
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
});
exports.validateAddPaymentMethodRequest = validateAddPaymentMethodRequest;
//# sourceMappingURL=AddPaymentMethod.js.map